<template>
    <div >
        
        <div class="echarts">
            <div class="search">
                <span class="title">土壤数据趋势</span>
                <!-- <el-date-picker
                    size="mini"
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <i class="el-icon-search">查询</i> -->
            </div>
            <div id="right3" style="width: 100%; height: 250px"></div>
        </div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import { getQX_weatherSoilTrend } from '../../api/api';
  export default {
    data () {
      return {
        date:"",
        // 查询参数
        query:{
          projectId:"1622845821245853697",
          startTime:"2023",
          endTime:"2023",
        },
        // echarts数据
        trssData:[],  // 土壤水势数据
        trwdData:[],  // 土壤温度数据
        trsdData:[],  // 土壤湿度数据
      }
    },
    created () { 
      this.projectId = JSON.parse(localStorage.getItem("projectId"))
      if(this.projectId ){
          this.getData(this.projectId)
      }
    },
    mounted () { 
      
      let _this = this
      window.addEventListener('setItemEvent', function(e) {
          const newdata = JSON.parse(e.newValue)
          console.log('值改变了',newdata)
          _this.getData(newdata)
      })
    },
    methods: {
      // 获取数据
      async getData(projectId){
        this.query.projectId = projectId
        let res = await getQX_weatherSoilTrend({
          ...this.query
        })
        console.log(res,"土壤数据趋势");
        if(res.code == 200){
          res.data.forEach(item => {
            this.trssData.push(item.wp)
            this.trwdData.push(item.st)
            this.trsdData.push(item.sm)
            this.drawEchat()
          });
        }
      },


      // 绘制echars表
      drawEchat() {
        let chartDom = document.getElementById("right3");
        if (chartDom.hasAttribute("_echarts_instance_")) {
          chartDom.removeAttribute("_echarts_instance_");
        }
        var myChart = echarts.init(chartDom);
        var option;
        option = {
          // title: {
          //   text: 'Stacked Line'
          // },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            textStyle:{
              color:"#fff",
            },
            top: 5
            // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
          },
          grid: {
            top: '25%',
            left: '3%',
            right: '4%',
            bottom: '2%',
            containLabel: true
          },
          toolbox: {
            // feature: {
            //   saveAsImage: {}
            // }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLine :{
              lineStyle:{
                color: "#fff"
              }
            },
            data: ['04-20', '04-21', '04-22', '04-23', '04-24', '04-25', '04-26', '04-27', '04-28', '04-29']
          },
          yAxis: {
            type: 'value',
            axisLine :{
              show:false,
              lineStyle:{
                color: "#fff"
              }
            },
          },
          series: [
            {
              name: '土壤水势',
              type: 'line',
              smooth: true,
              stack: 'Total',
              data: this.trssData
            },
            {
              name: '土壤温度',
              type: 'line',
              smooth: true,
              stack: 'Total',
              data: this.trwdData
            },
            {
              name: '土壤湿度',
              type: 'line',
              smooth: true,
              stack: 'Total',
              data: this.trsdData
            },
          ]
        };
  
        option && myChart.setOption(option);
      },
      
    },
    
  }
  </script>
  <style lang="scss" scoped>
  
  .echarts{
    padding: 18px 9px 10px 10px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    .search{
        margin-bottom: 5px;
        .title{
            font-size: 20px;
            font-weight: bold;
            margin-right: 10px;
        }
        >i{
            font-size: 16px;
            margin-left: 10px;
        }
    }
  }
  
  </style>
  